import Main from "./../components/Main/index";
const urlPerfix = "/main";

export default [
  {
    path: `${urlPerfix}/profile`,
    component: Main,
    exact: true,
    button: {
      icon: "md md-account",
      title: "پروفایل"
    }
  },
  {
    path: `${urlPerfix}/history`,
    component: Main,
    button: {
      icon: "md md-view-list-alt",
      title: "تاریخچه"
    }
  },
  {
    path: `${urlPerfix}/`,
    component: Main,
    exact: true,
    button: {
      icon: "md md-plus",
      isMain: true
    }
  },
  {
    path: `${urlPerfix}/confirm`,
    component: Main,
    exact: true,
    button: {
      icon: "md md-assignment-check",
      title: "تایید نهایی"
    }
  },
  {
    path: `${urlPerfix}/test`,
    component: Main,
    exact: true,
    button: {
      icon: "md md-pin-help",
      title: "تست"
    }
  }
];
